import { useTranslation } from 'next-i18next'
import { Price } from '~/components/price'
import { useUserContext } from '~/providers/user-provider'
import { useWallet } from '../wallet/use-wallet.hook'
import { DashboardCard } from './dashboard-card'

export const DashboardWalletCard = () => {
	const { t } = useTranslation()
	const { accountQuery } = useUserContext()
	const wallet = useWallet()

	return (
		<DashboardCard
			isLoading={accountQuery.isLoading}
			title={t('cwDashboard:wallet.title') as string}
			link={{
				label: t('cwDashboard:wallet.linkLabel'),
				href: '/my-account/wallet',
			}}
			childrenClassName='text-6xl font-bold leading-none text-primary'
		>
			<Price
				price={wallet.data?.amount || 0}
				className='font-bold text-6xl text-primary leading-none'
			/>
		</DashboardCard>
	)
}
